module.exports = __webpack_public_path__ + "img/nube-file.f77f7a71.svg";